import React, { Component } from 'react';
import logo from '../assets/images/logo.svg';

import movie from '../assets/video.mp4';
import movieSmall from '../assets/video-small.mp4';


class Intro extends Component {
  constructor(props) {
    super(props);
    this.videoContainerRef = React.createRef();
    this.videoRef = React.createRef();
    this.videoPausedByFade = false;
  }

  handleScroll = () => {
    const container = this.videoContainerRef.current;
    const video = this.videoRef.current;
    if (!container || !video) return;

    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;

    // ---- Progress ----
    let progress = Math.min(scrollY / viewportHeight, 1);

    // ---- Crop & scale ----
    const fastProgress = Math.min(progress * 1, 1);
    const scale = 1 - 0.6 * fastProgress;
    const radius = 20 * fastProgress;

    const videoWidth = video.videoWidth || video.clientWidth;
    const videoHeight = video.videoHeight || video.clientHeight;

    let top = 0, right = 0, bottom = 0, left = 0;

    if (videoWidth > videoHeight) {
      const extraWidth = videoWidth - videoHeight;
      const maxInsetPercent = (extraWidth / videoWidth / 2) * 100;
      left = right = maxInsetPercent * fastProgress;
    } else if (videoHeight > videoWidth) {
      const extraHeight = videoHeight - videoWidth;
      const maxInsetPercent = (extraHeight / videoHeight / 2) * 100;
      top = bottom = maxInsetPercent * fastProgress;
    }

    // ---- Fade & pause ----
    const pausePoint = 0.96; // pause at 90%
    const fadeDuration = 1; // fade out over next 20%
    const fadeStart = pausePoint;
    const fadeEnd = pausePoint + fadeDuration;

    // pause video once we hit pausePoint
    if (fastProgress >= pausePoint && !this.videoPausedByFade) {
      video.pause();
      this.videoPausedByFade = true;
    } else if (fastProgress < pausePoint && this.videoPausedByFade) {
      video.play().catch(() => {});
      this.videoPausedByFade = false;
    }

    // fade out after pause
    let opacity = 1;
    if (fastProgress >= fadeStart && fastProgress <= 1) {
      opacity = 1 - (fastProgress - fadeStart) / (1 - fadeStart);
    } else if (fastProgress > 1) {
      opacity = 0;
    }

    // ---- Apply styles ----
    container.style.transform = `translate(-50%, -50%) scale(${scale})`;
    container.style.borderRadius = `${radius}px`;
    container.style.clipPath = `inset(${top}% ${right}% ${bottom}% ${left}%)`;
    container.style.opacity = opacity;
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    return (
     
     
     <div>
     <div className="video-container uk-position-fixed uk-position-center" ref={this.videoContainerRef}>
        <video
          ref={this.videoRef}
          className="uk-object-fill"
          muted
          autoPlay
          loop
          playsInline
        >
          {/* Mobile first */}
          <source src={movieSmall} type="video/mp4" media="(max-width: 767px)" />
          <source src={movie} type="video/mp4" media="(min-width: 768px)" />
        </video>
        <div style={{fontSize:"30px"}}className="uk-text-center uk-hidden@s	" > ▼ •ᴗ• ▼ </div>
        
      </div>

      </div>
    );
  }
}

export default Intro;
